var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"h3 mb-4 text-gray-800"},[_vm._v("Blank Page")])])}]

export { render, staticRenderFns }